export default
{
    path: '/',
    name: 'MainPage',
    component: () => import('../views/main/index.vue'),
    children:[
      {
        path: "/",
        name: "main",
        component: () => import('../views/main/Introduce.vue'),
      },
      {
        path: "partyBuild",
        name: "partyBuild",
        component: () => import('../views/main/partyBuild.vue'),
      },
      {
        path: "netAcc",
        name: "netAcc",
        component: () => import('../views/main/netAcc.vue'),
      },
      {
        path: "partyRules",
        name: "partyRules",
        component: () => import('../views/main/partyRules.vue'),
      },
      {
        path: "partyYearsReport",
        name: "partyYearsReport",
        component: () => import('../views/main/partyYearsReport.vue'),
      },
      {
        path: "fundProject",
        name: "fundProject",
        component: () => import('../views/main/fundProject.vue'),
      },
      {
        path: "fundDetail",
        name: "fundDetail",
        component: () => import('../views/main/fundDetail.vue'),
      },
      {
        path: "partyDetail",
        name: "partyDetail",
        component: () => import('../views/main/partyDetail.vue'),
      },
      {
        path: "aboutus",
        name: "aboutus",
        component: () => import('../views/main/aboutus.vue'),
      },
      {
        path: "newsDetail",
        name: "newsDetail",
        component: () => import('../views/main/newsDetail.vue'),
      },
      {
        path: "newsList",
        name: "newsList",
        component: () => import('../views/main/newsMoreList.vue'),
      },
      {
        path: "newsDetail",
        name: "newsDetail",
        component: () => import('../views/main/newsDetail.vue'),
        props: (route) => (
          {
              detailId: route.query.detailId
          }
      ),
      },
      {
        path: "nothing",
        name: "nothing",
        component: () => import('../views/main/nothing.vue'),
      },
    ]
  }